var _path, _path2, _path3, _path4, _path5, _path6;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgInviteUserOutlined(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4H27.5121C27.287 4.63682 27.1316 5.30654 27.0549 6H6C3.79086 6 2 7.79086 2 10V32C2 36.4183 5.58172 40 10 40H28C32.4183 40 36 36.4183 36 32V16C36.6874 16 37.3568 15.9229 38 15.777V32C38 37.5228 33.5228 42 28 42H10C4.47715 42 0 37.5228 0 32V10C0 6.68629 2.68629 4 6 4Z",
    fill: "var(--secondary-3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9996 13.2257C39.436 13.2257 42.2218 10.4399 42.2218 7.00347C42.2218 3.56703 39.436 0.78125 35.9996 0.78125C32.5631 0.78125 29.7773 3.56703 29.7773 7.00347C29.7773 10.4399 32.5631 13.2257 35.9996 13.2257ZM35.2704 10.8923V7.73263H32.1107V6.27429H35.2704V3.11457H36.7287V6.27429H39.8884V7.73263H36.7287V10.8923H35.2704Z",
    fill: "var(--secondary-7)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3301 16C20.3301 18.2091 18.5392 20 16.3301 20C14.1209 20 12.3301 18.2091 12.3301 16C12.3301 13.7909 14.1209 12 16.3301 12C18.5392 12 20.3301 13.7909 20.3301 16Z",
    fill: "var(--secondary-3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8921 18.5738C21.4774 17.8782 21.83 16.9803 21.83 16C21.83 15.8898 21.8256 15.7807 21.8168 15.6728C22.3142 15.253 22.9568 15 23.6586 15C25.2366 15 26.5158 16.2792 26.5158 17.8571C26.5158 19.4351 25.2366 20.7143 23.6586 20.7143C22.3281 20.7143 21.2101 19.8049 20.8921 18.5738Z",
    fill: "var(--secondary-3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.33 30.9V25.5C24.33 23.8639 23.6157 22.3947 22.4819 21.3872C22.8585 21.2929 23.2527 21.2428 23.6586 21.2428C26.3253 21.2428 28.4872 23.4047 28.4872 26.0714V30.9H24.33Z",
    fill: "var(--secondary-3)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83008 27.5V34H22.8301V27.5C22.8301 23.9101 19.9199 21 16.3301 21C12.7402 21 9.83008 23.9101 9.83008 27.5Z",
    fill: "var(--secondary-3)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteUserOutlined);
export default __webpack_public_path__ + "static/media/inviteUserOutlined.7f68a713da64c3b383c919d900551a68.svg";
export { ForwardRef as ReactComponent };